var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"max-width":"100% !important"}},[_c('div',{attrs:{"id":"main"}}),_c('div',{staticClass:"text",attrs:{"title":_vm.evaluation}},[_c('div',{staticStyle:{"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis","width":"80%"}},[_vm._v(_vm._s(_vm.evaluation))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }